import { createElement, forwardRef } from "react";
import { m, useReducedMotion } from "framer-motion";
import { hoverButton, hoverTransition } from "../../../utils/motionVariants";
import { getMotionComponent, resolveTag } from "./motionPrimitives";

/**
 * Premium button micro-interaction — scale + lift. Transform only.
 */
const HoverButton = forwardRef(function HoverButton(
  { as = "button", className = "", children, ...props },
  ref
) {
  const reduceMotion = useReducedMotion();
  const tag = resolveTag(as);

  if (reduceMotion) {
    return createElement(tag, { ref, className, ...props }, children);
  }

  const Component = getMotionComponent(m, tag);

  return createElement(
    Component,
    {
      ref,
      initial: "rest",
      whileHover: "hover",
      whileTap: "tap",
      variants: hoverButton,
      transition: hoverTransition,
      className,
      ...props,
    },
    children
  );
});

HoverButton.displayName = "HoverButton";

export default HoverButton;
